// File: frontend/src/context/UiLanguageContext.js
// Version: 1.0 (2026-09-28, Phase 9 — план 09-04)
// Description: язык интерфейса арендатора. Список языков и умолчание берутся ТОЛЬКО
// из признаков арендатора (`useBranding().features.ui_languages / ui_language_default`),
// а не из имени арендатора. У арендатора без признака (features пуст) языков нет:
// lang = null, переключатель не рисуется, t() отдаёт EN-словарь.
//
// 🔴 Хранилище выбора — localStorage под ключом `ui_lang:<instance>`. Всё обращение
//    к нему (включая САМО чтение свойства window.localStorage — в приватном режиме
//    Safari бросает уже оно) обёрнуто в try/catch: сбой хранилища не ломает экран.

import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useBranding } from './BrandingContext';
import { perevesti } from '../i18n/today';

export const kluchYazyka = (inst) => `ui_lang:${inst || 'unknown'}`;

export function prochitatYazyk(inst) {
    try {
        const hranilishche = window.localStorage;
        if (!hranilishche) return null;
        return hranilishche.getItem(kluchYazyka(inst));
    } catch (e) {
        return null;
    }
}

export function zapisatYazyk(inst, yazyk) {
    try {
        const hranilishche = window.localStorage;
        if (!hranilishche) return false;
        hranilishche.setItem(kluchYazyka(inst), yazyk);
        return true;
    } catch (e) {
        return false;
    }
}

/** сохранённый ∈ ui_languages → он; иначе default ∈ ui_languages → он; иначе ui_languages[0]; иначе null. */
export function vybratYazyk(sohranyonnyy, features) {
    const f = features || {};
    const yazyki = Array.isArray(f.ui_languages) ? f.ui_languages : [];
    if (yazyki.length === 0) return null;
    if (sohranyonnyy && yazyki.includes(sohranyonnyy)) return sohranyonnyy;
    if (f.ui_language_default && yazyki.includes(f.ui_language_default)) return f.ui_language_default;
    return yazyki[0];
}

const NET_YAZYKOV = Object.freeze([]);
const NET_PRIZNAKOV = Object.freeze({});

const UiLanguageContext = createContext({
    lang: null,
    setLang: () => {},
    languages: NET_YAZYKOV,
    t: (k, v) => perevesti('en', k, v),
});

export const useUiLanguage = () => useContext(UiLanguageContext);

export const UiLanguageProvider = ({ children }) => {
    const { branding, features: syryePriznaki } = useBranding();
    const features = syryePriznaki || NET_PRIZNAKOV;
    const inst = branding && branding.instance_name;
    const languages = Array.isArray(features.ui_languages) ? features.ui_languages : NET_YAZYKOV;

    const [lang, setLangState] = useState(null);

    useEffect(() => {
        setLangState(vybratYazyk(prochitatYazyk(inst), features));
    }, [inst, features]);

    const setLang = useCallback((v) => {
        if (!languages.includes(v)) return;
        setLangState(v);
        zapisatYazyk(inst, v);
    }, [languages, inst]);

    const umolchanie = features.ui_language_default;
    const t = useCallback(
        (key, vars) => perevesti(lang || umolchanie || 'en', key, vars),
        [lang, umolchanie],
    );

    const value = useMemo(() => ({ lang, setLang, languages, t }), [lang, setLang, languages, t]);

    return <UiLanguageContext.Provider value={value}>{children}</UiLanguageContext.Provider>;
};
